import { Injectable, inject } from "@angular/core";
import { Location } from "@angular/common";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { tap, map } from "rxjs/operators";

import { CoreActions } from "../actions";
@Injectable()
export class CoreEffects {
  private location = inject(Location);
  private actions$ = inject(Actions);
  private router = inject(Router);

  navigateBack$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(CoreActions.TYPES.BACK),
        tap(() => this.location.back()),
      ),
    { dispatch: false },
  );

  navigateForward$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(CoreActions.TYPES.FORWARD),
        tap(() => this.location.forward()),
      ),
    { dispatch: false },
  );

  navigate$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(CoreActions.TYPES.GO),
        map((action: CoreActions.Go) => action.payload),
        tap(({ path, query: queryParams, extras }) => {
          console.log("NAVIGATE", { path, query: queryParams, extras });
          this.router.navigate(path, { queryParams, ...extras });
        }),
      ),
    { dispatch: false },
  );
}
